<template>
  <basic-container style="padding-bottom: 50px !important;">
    <avue-form :option="option"></avue-form>
  </basic-container>
</template>

<script>
import { getFormById } from '@/api/form';
export default {
  data() {
    return {
      // obj:{},
      // sizeValue:'small'
      option: '',
    };
  },
  created() {
    let formId = this.$route.query.id;
    let self = this;
    getFormById(formId).then((res) => {
      console.log(res.data);
      self.option = JSON.parse(res.data.detail);
    });
  },
  activated() {
    let formId = this.$route.query.id;
    let self = this;
    getFormById(formId).then((res) => {
      console.log(res.data);
      self.option = JSON.parse(res.data.detail);
    });
  },
  methods() {},
};
</script>

<style></style>
